import React from 'react';



const MessageA39 = (props) => {


    return(
<div>{props.item.text}</div>
    )
}

export default MessageA39;
